import { useEffect, useState } from 'react'
import { apiGet } from './api.js'

/**
 * employee_id → readable staff code for one branch+day roster.
 *
 * The same list the upsell picker assigns from, so it names every assignee a
 * plan can carry — a name only goes missing when the roster was edited after the
 * plan was saved, and those fall back to `#id` rather than disappearing.
 *
 * Day-scoped on purpose: the roster is different every day, so there is nothing
 * useful to resolve over a month range (the month view shows plan COUNTS, not
 * names). Fails quiet to an empty map.
 */
export function useHuddleStaff(branchId, date) {
  const [names, setNames] = useState(() => new Map())
  useEffect(() => {
    if (!branchId || !date) { setNames(new Map()); return }
    let alive = true
    apiGet('/api/huddle-staff', { date, branch_id: branchId })
      .then((r) => {
        if (!alive) return
        setNames(new Map((Array.isArray(r?.staff) ? r.staff : []).map((m) => [Number(m.employee_id), m.code])))
      })
      .catch(() => { if (alive) setNames(new Map()) })
    return () => { alive = false }
  }, [branchId, date])
  return names
}

// Plan assignee ids → display names, in stored order.
export const assigneeNames = (ids, staffNames) =>
  (Array.isArray(ids) ? ids : []).map((id) => staffNames?.get?.(Number(id)) || `#${id}`)
